import { useEffect } from 'react'

import { capitalizeFirstLetter } from 'utils'
import { getClosestGenreDuration } from './helpers'

import * as Styled from './styled'
import { MusicLibSounds } from './music-lib-sounds'
import { audioThunks } from 'store/features/audio/thunks'
import { audioSelectors } from 'store/features/audio/selectors'
import { dispatch } from 'store'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'

interface IProps {
  activeGenreName: string
  onCloseActiveGenreView: () => void
  setActiveGenreNameCallback: (name: string) => void
}

export const MusicLibrary: React.FC<IProps> = props => {
  const {
    activeGenreName,
    onCloseActiveGenreView,
    setActiveGenreNameCallback
  } = props
  const soundsGenresWithoutSounds = useSelector(
    audioSelectors.soundsGenresWithoutSounds
  )
  const genresDuration = useSelector(audioSelectors.genresDuration)

  const projectDuration = useSelector(projectDataSelectors.duration)

  useEffect(() => {
    if (
      genresDuration === null ||
      getClosestGenreDuration(projectDuration) !== genresDuration
    ) {
      dispatch(audioThunks.getSoundsGenres())
    }
  }, [projectDuration, genresDuration])

  if (activeGenreName) {
    return (
      <MusicLibSounds
        activeGenreName={activeGenreName}
        onBackButtonClick={onCloseActiveGenreView}
      />
    )
  }

  return (
    <Styled.MusicLibraryWrapper>
      {soundsGenresWithoutSounds.map(libItem => {
        return (
          <Styled.MusicLibItem
            $background={libItem.thumbnail}
            key={libItem.genre}
            onClick={() => setActiveGenreNameCallback(libItem.genre)}
          >
            <Styled.MusicLibItemLabel type="h4" color={'white'}>
              {capitalizeFirstLetter(libItem.genre)}
            </Styled.MusicLibItemLabel>
          </Styled.MusicLibItem>
        )
      })}
    </Styled.MusicLibraryWrapper>
  )
}
